import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        
        this.events = {
            click: {
                button: 'toggleSound'
            }
        }
    }

    init() {

        this.$video = this.$('video')[0];
        this.$video.currentTime = 0.1;

        this.$video.addEventListener('canplay',() => {
            this.call('refresh','Scroll','main');
        });
    }

    trigger(e) {
        if(e.mode == 'enter') {
            this.$video.play();
        } else {
            this.$video.pause();
        }
    }

    toggleSound() {
        let isMuted = this.$video.muted;

        if(isMuted) {
            this.$video.muted = false;
        } else {
            this.$video.muted = true;
        }
        
        if(this.$video.muted) {
            this.el.classList.remove('has-sound');
        } else {
            this.el.classList.add('has-sound');
        }
    }
}
